<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="工种名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入工种名称" />
      </a-form-model-item>
      <a-form-model-item label="首字母" prop="initial" >
        <a-input v-model="form.initial" placeholder="请输入工种名称首字母（如：A）" :maxLength="1" style="text-transform: uppercase" />
      </a-form-model-item>
      <!-- <a-form-model-item label="请选择上级" prop="parentId" >
        <a-select v-model="form.parentId" placeholder="请选择上级分类">
          <a-select-option v-for="item in categoryList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="是否需要认证" prop="certificate" >
        <a-select v-model="form.certificate" placeholder="请选择是否需要认证">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="保险分类" prop="insurance" >
        <a-select v-model="form.insurance" placeholder="请选择保险分类">
          <a-select-option :value="1">A类</a-select-option>
          <a-select-option :value="2">B类</a-select-option>
          <a-select-option :value="3">C类</a-select-option>
          <a-select-option :value="4">D类</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="证书名称" prop="certificateName" v-if="form.certificate == 1">
        <a-input v-model="form.certificateName" placeholder="请输入证书名称" />
      </a-form-model-item>
<!--      <a-form-model-item label="工种状态" prop="type" >-->
<!--        <a-select v-model="form.type" placeholder="请选择工种状态">-->
<!--          <a-select-option :value="0">工种层级</a-select-option>-->
<!--          <a-select-option :value="1">标签</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <!-- <a-form-model-item label="层级" prop="status" >
        <a-select v-model="form.status" placeholder="请选择层级">
          <a-select-option :value="0">顶级</a-select-option>
          <a-select-option :value="1">一级</a-select-option>
          <a-select-option :value="2">二级</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="保险费用" prop="insuranceMoney" >
        <a-input v-model="form.insuranceMoney" placeholder="请输入保险费用" />
      </a-form-model-item>
      <a-form-model-item label="保证金费用" prop="suretyMoney" >
        <a-input v-model="form.suretyMoney" placeholder="请输入保证金费用" />
      </a-form-model-item>
           <a-form-model-item label="是否售后" prop="isAfter" >
       <a-select v-model="form.isAfter" placeholder="请选择是否售后">
         <a-select-option :value="0">否</a-select-option>
         <a-select-option :value="1">是</a-select-option>
       </a-select>
     </a-form-model-item>
     <a-form-model-item label="是否必须买保险" prop="isInsurance" >
       <a-select v-model="form.isInsurance" placeholder="请选择是否必须买保险">
         <a-select-option :value="0">否</a-select-option>
         <a-select-option :value="1">是</a-select-option>
       </a-select>
     </a-form-model-item>
     
     <a-form-model-item label="是否常用工种" prop="regular" >
       <a-select v-model="form.regular" placeholder="请选择是否为常用工种">
         <a-select-option :value="0">否</a-select-option>
         <a-select-option :value="1">是</a-select-option>
       </a-select>
     </a-form-model-item>
     <a-form-model-item label="抽佣比例" prop="ratio" >
       <a-input-number
         v-model="form.ratio"
         :min="0"
         :max="1"
         :precision="2"
         :step="0.01"
         placeholder="请输入抽佣比例"
         style="width: 100%"
       />
     </a-form-model-item>
     <a-form-model-item label="封顶金额" prop="maxPrice" >
       <a-input-number
         v-model="form.maxPrice"
         :min="0"
         :precision="2"
         :step="0.01"
         placeholder="请输入封顶金额"
         style="width: 100%"
       />
     </a-form-model-item>
      <a-form-model-item label="佣金冻结天数" prop="commissionFreezeDays" >
        <a-input-number
          v-model="form.commissionFreezeDays"
          :min="0"
          :max="36500"
          :precision="0"
          placeholder="请输入佣金冻结天数"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="匹配关键词" prop="keywords" >
        <a-textarea v-model="form.keywords" placeholder="多个关键词用英文逗号分隔（中文逗号会自动转换）" :auto-size="{ minRows: 2, maxRows: 4 }" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCategory, addCategory, updateCategory, listCategory } from '@/api/category/category'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      categoryList: [],
      // 表单参数
      form: {
        id: null,

        name: null,

        initial: null,

        parentId: undefined,

        certificate: undefined,

        insurance: undefined,

        certificateName: null,

        type: 0,

        status: undefined,

        insuranceMoney: null,

        suretyMoney: null,

        createTime: null,

        remark: null,
        isAfter: 0,
        isInsurance: 0,
        regular: 0,
        ratio: null,
        maxPrice: null,
        commissionFreezeDays: 0,
        keywords: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '工种名称不能为空', trigger: 'blur' }
        ],
        // parentId: [
        //   { required: true, message: '上级id不能为空', trigger: 'blur' }
        // ],
        certificate: [
          { required: true, message: '是否需要认证不能为空', trigger: 'blur' }
        ],
        insurance: [
          { required: true, message: '保险分类不能为空', trigger: 'blur' }
        ],

        type: [
          { required: true, message: '工种状态不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '层级不能为空', trigger: 'blur' }
        ],
        ratio: [
          {
            validator: (rule, value, callback) => {
              if (value !== null && value !== undefined && value !== '') {
                if (value < 0) {
                  callback(new Error('抽佣比例不能为负数'))
                } else {
                  // 检查小数位数
                  const str = value.toString()
                  const decimalIndex = str.indexOf('.')
                  if (decimalIndex !== -1 && str.substring(decimalIndex + 1).length > 2) {
                    callback(new Error('抽佣比例最多保留2位小数'))
                  } else {
                    callback()
                  }
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        maxPrice: [
          {
            validator: (rule, value, callback) => {
              if (value !== null && value !== undefined && value !== '') {
                if (value < 0) {
                  callback(new Error('封顶金额不能为负数'))
                } else {
                  // 检查小数位数
                  const str = value.toString()
                  const decimalIndex = str.indexOf('.')
                  if (decimalIndex !== -1 && str.substring(decimalIndex + 1).length > 2) {
                    callback(new Error('封顶金额最多保留2位小数'))
                  } else {
                    callback()
                  }
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        commissionFreezeDays: [
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('佣金冻结天数不能为空'))
                return
              }
              const n = Number(value)
              if (Number.isNaN(n) || n < 0) {
                callback(new Error('佣金冻结天数不能小于0'))
                return
              }
              if (n > 36500) {
                callback(new Error('佣金冻结天数超出合理范围'))
                return
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]

      }
    }
  },
  mounted () {
    this.getCategoryList()
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1

      this.$nextTick(() => {
        this.form = {
          id: null,
          name: null,
          initial: null,
          parentId: undefined,
          certificate: undefined,
          insurance: undefined,
          certificateName: null,
          type: 0,
          status: undefined,
          insuranceMoney: null,
          suretyMoney: null,
          createTime: null,
          remark: null,
          isAfter: 0,
          isInsurance: 0,
          regular: 0,
          ratio: null,
          maxPrice: null,
          commissionFreezeDays: 0,
          keywords: null
        }
      })
    },

    getCategoryList () {
      listCategory({ type: 2 }).then(response => {
        this.categoryList = response.data
      })
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCategory({ id }).then(response => {
        this.form = response.data
        if (this.form.commissionFreezeDays == null || this.form.commissionFreezeDays === '') {
          this.$set(this.form, 'commissionFreezeDays', 0)
        }
        if (this.form.regular == null || this.form.regular === '') {
          this.$set(this.form, 'regular', 0)
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
